import * as React from 'react';
import * as ReactDOM from 'react-dom';
import '@babel/polyfill';
import { setWebpackPublicFromBackend } from '../utility/customize-webpack';
import { attemptRegisterForDevs } from '../dev/dev-barrier/register';
import { LogoutSuccess } from '../components/LogoutSuccess';

let LogoutSuccessRoot: any = LogoutSuccess;

if (process.env.NODE_ENV === 'development') {
  // Enable hot module reload for dev builds
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { hot } = require('react-hot-loader');
  LogoutSuccessRoot = hot(module)(LogoutSuccess);
}

const anchorDiv = document.querySelector('#logout-success');

if (anchorDiv) {
  setWebpackPublicFromBackend();

  attemptRegisterForDevs();

  ReactDOM.render(
    <LogoutSuccessRoot />,
    anchorDiv
  );

  const html = document.querySelector('html');
  if (html) {
    html.setAttribute('lang', 'en');
  }
}
